import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CurrencyInputComponent } from './currency-input.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { NgxCurrencyDirective } from "ngx-currency";
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        InputMaskModule,
        NgxCurrencyDirective,
        AngularMaterialLibraryModule,
        DirectiveLibraryModule,
        CurrencyInputComponent,
    ],
    exports: [
        CurrencyInputComponent,
    ]
})
export class CurrencySelectionModule {

}
